/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
**************************************************************************/

import { RENDITION_SCRIPT_NAME } from "../utils/constants";

export const getOriginFromUrl = url => {
    const aEl = document.createElement("a");
    aEl.href = url;
    return `${aEl.protocol}//${aEl.hostname}${aEl.port ? `:${aEl.port}` : ""}`;
};

/**
 * @param {string} targetScriptName script whose source needs to be determined
 * @returns path for target script, if exists in document.scripts
 */
export const getScriptSrc = targetScriptName => {
    const scripts = document.scripts;
    const targetScript = [...scripts].find(script => script.src.indexOf(targetScriptName) !== -1);
    return targetScript?.src;
};

/**
 * AcrobatJS module path is relative to
 * rendition.js as it is bundled with it.
 * @returns path to AcrobatJS module.
 */
export const getAjsPath = () => {
    const pathToScript = getScriptSrc(RENDITION_SCRIPT_NAME);
    const versionRegex = /\/(\d+\.\d+\.\d+_)?\d+\.\d+\.\d+\/rendition\.js$/;
    const match = versionRegex.exec(pathToScript);
    let pathToAjs = pathToScript;
    if (match) {
        pathToAjs = `${pathToScript.substring(0, match.index + 1)}AJS/`;
    } else {
        pathToAjs = pathToScript
            ? `${pathToScript.replace(RENDITION_SCRIPT_NAME, "")}AJS/`
            : "";
    }
    return pathToAjs;
};
